jQuery(function initTurnstileForm($) {

	$('#form-contact-us').each(function(index, el) {

		var $container = $(this);
		var $submitBtn = $container.find('.btn-submit');

		$submitBtn.click(function() {

			var fieldCheck  = true;
			var submitCheck = true;

			$('.js-fh-error-missing-fields-error').css('display','none');
			$('.js-fh-error-turnstile-error').css('display','none');

			$container.find('.form-control').each(function() {
				
				if ( $(this).val() === '' ) {
					$('.js-fh-error-missing-fields-error').css('display','block');
					fieldCheck = false;		
				}
			});

			if (fieldCheck) {

				var response = turnstile.getResponse();

				$.ajax({
					method: "POST",
					url: "/h/site/VerifyTurnstileResponse",
					async: false, // necessary to ensure the AJAX completes (potentially setting 'submitCheck') before submitting the form to salesforce
					data: { turnstileResponse: response }
				})
				.done(function( data ) {
					
					var dataJSON = JSON.parse(data);

					if (dataJSON !== '') {

						if (dataJSON.type === 'failure') {

							 $('.js-fh-error-turnstile-error').css('display','block');
							 submitCheck = false;
						}
					}
				});

				if (submitCheck) {

					return true;
				}
				else {

					if (typeof turnstile !== 'undefined') {

						turnstile.reset('#my-turnstile');
					}

					return false;
				}
			}
			else {

				if (typeof turnstile !== 'undefined') {

					turnstile.reset('#my-turnstile');
				}

				return false;
			}
		});
	});
});